"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _reactRouterDom = require("react-router-dom");
var _FlatButton = _interopRequireDefault(require("material-ui/FlatButton"));
var _MenuItem = _interopRequireDefault(require("material-ui/MenuItem"));
var _chevronRight = _interopRequireDefault(require("material-ui/svg-icons/navigation/chevron-right"));
var _Accordion = _interopRequireDefault(require("../Accordion"));
var _Select = _interopRequireDefault(require("../Select"));
var _Slider = _interopRequireDefault(require("../Slider"));
var _PopupList = _interopRequireDefault(require("../PopupList"));
var _PopupListWithFilter = _interopRequireDefault(require("../PopupListWithFilter"));
var _InputText = _interopRequireDefault(require("../InputText"));
var _Toggle = _interopRequireDefault(require("../Toggle"));
var _LabelInfo = _interopRequireDefault(require("../LabelInfo"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _ListItem = _interopRequireDefault(require("./ListItem"));
require("./List.scss");
var _muiThemeable = _interopRequireDefault(require("material-ui/styles/muiThemeable"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); } // import ColorPicker from "../ColorPicker";
/**
 * @description this component allows for the creation of a list of components
 * they could be inputs, buttons, or navigation items
 * the default type assumes an input, and its default is a text input
 * @props (Array)
 *
 */
var List = /*#__PURE__*/function (_Component) {
  _inherits(List, _Component);
  var _super = _createSuper(List);
  function List(props) {
    var _this;
    _classCallCheck(this, List);
    _this = _super.call(this, props);
    _this.state = {
      items: _objectSpread({}, props.items),
      data: _objectSpread({}, props.data)
    };
    return _this;
  }
  _createClass(List, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // the catch is we need to be sure all the children have mounted and displayed correct before doing this
      if (this.props.needRefresh) {
        this.props.toggleNeedRefresh(false);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        items: nextProps.items,
        data: nextProps.data
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      // Checking if items need sorting
      var itemsToBeOrdered = [];
      var itemsNotOrdered = [];
      var orderedTotal = [];
      (0, _map2["default"])(this.state.items, function (item) {
        if (typeof item.order !== 'undefined') {
          itemsToBeOrdered.push(item);
        } else {
          itemsNotOrdered.push(item);
        }
      });
      itemsToBeOrdered.sort(function (a, b) {
        return a.order - b.order;
      });
      // _map(itemsToBeOrdered, item => {
      //   orderedTotal.push(item);
      // });
      // _map(itemsNotOrdered, item => {
      //   orderedTotal.push(item);
      // });
      orderedTotal = orderedTotal.concat(itemsToBeOrdered, itemsNotOrdered);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "cms-list col-sm-12",
        id: this.props.id
      }, (0, _map2["default"])(orderedTotal, function (item) {
        var key = item.param || item.label;
        // If the item in the list is an asset for an assetEditor, we pass all the data inside and do not look for the key
        // @TODO: Find a better way of handling the above
        var data = _this2.state.data ? item.type === 'assetEditor' ? _this2.state.data[key] || _this2.state.data : typeof _this2.state.data[key] !== 'undefined' ? _this2.state.data[key] : '' : null;
        return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
          data: data,
          handleInputChange: _this2.props.handleInputChange,
          handleEditClick: _this2.props.handleEditClick,
          handleAddClick: _this2.props.handleAddClick,
          handleDeleteClick: _this2.props.handleDeleteClick,
          handleFrameSetterFunc: _this2.props.handleFrameSetterFunc,
          icon: _this2.props.icon,
          injectLanguage: _this2.props.injectLanguage,
          language: _this2.props.language,
          muiTheme: _this2.props.muiTheme,
          needRefresh: _this2.props.needRefresh,
          styleName: _this2.props.styleName,
          slugBase: _this2.props.slugBase,
          key: item.param || item.label,
          item: item
        });
      }));
    }
  }]);
  return List;
}(_react.Component);
List.defaultProps = {
  needRefresh: false,
  styleName: 'standard'
};
List.propTypes = {
  handleInputChange: _propTypes["default"].func,
  icon: _propTypes["default"].string,
  items: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  muiTheme: _propTypes["default"].object,
  // Object inheriting Material UI Context styles
  needRefresh: _propTypes["default"].bool,
  toggleNeedRefresh: _propTypes["default"].func,
  styleName: _propTypes["default"].string,
  slugBase: _propTypes["default"].string,
  injectLanguage: _propTypes["default"].bool,
  language: _propTypes["default"].string,
  handleEditClick: _propTypes["default"].func,
  handleAddClick: _propTypes["default"].func,
  handleDeleteClick: _propTypes["default"].func,
  handleFrameSetterFunc: _propTypes["default"].func,
  data: _propTypes["default"].object
};

// export default List;
var _default = (0, _muiThemeable["default"])()(List);
exports["default"] = _default;